import { render, staticRenderFns } from "./DataTableRowHandler.vue?vue&type=template&id=5d20f6e2"
import script from "./DataTableRowHandler.vue?vue&type=script&lang=js"
export * from "./DataTableRowHandler.vue?vue&type=script&lang=js"
import style0 from "./DataTableRowHandler.vue?vue&type=style&index=0&id=5d20f6e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports